import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { get } from 'lodash';
import {
  Container, Row, Col, Card, CardBody,
} from 'reactstrap';

import { ButtonLink } from 'components/Button';
import ShieldIcon from './components/ShieldIcon';
import './style.scss';

// Seconds before the user is automatically redirected to the sign-in screen.
const REDIRECT_SECONDS = 6;

/**
 * "Verification successful" — shown after a user confirms their email (or phone)
 * during sign-up. Confirms success, offers a link to proceed to sign in, and
 * automatically redirects to the sign-in screen after a short countdown.
 *
 * The verified channel ("email" or "phone") is passed via router state so the
 * copy reads correctly; it defaults to "email".
 */
const VerificationSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // "email" (default) or "phone" — controls the confirmation copy.
  const channel = get(location, 'state.channel', 'email');
  const [secondsLeft, setSecondsLeft] = useState(REDIRECT_SECONDS);

  useEffect(() => {
    // Tick the countdown once per second and redirect to sign-in when it hits 0.
    const timer = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  const handleSignInClick = () => navigate('/');

  return (
    <div className="two-factor-page">
      <Container fluid>
        <Row>
          <Col>
            <Card className="tf-card">
              <CardBody className="p-4 text-center">
                <div className="mb-3">
                  <span className="tf-shield"><ShieldIcon /></span>
                </div>

                <h3 className="tf-title">Congratulations!</h3>
                <p className="tf-subtitle">
                  You have successfully verified your
                  {' '}
                  {channel}
                  . Please proceed to
                  {' '}
                  <ButtonLink className="tf-link d-inline" onClick={handleSignInClick}>
                    Sign In
                  </ButtonLink>
                  .
                </p>

                <p className="tf-subtitle mb-0">
                  You will be automatically redirected in
                  {' '}
                  <strong>{secondsLeft}</strong>
                  {' '}
                  {secondsLeft === 1 ? 'second' : 'seconds'}
                  .
                </p>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default VerificationSuccess;
